// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!../../ToastTokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable property-disallowed-list -- this file is part of the design system */

.Toast-module__Container__KicHb {
    display: flex;
    gap: var(--ds-s);
    align-items: center;
    justify-content: space-between;
    min-width: var(--ds-100x);
    max-width: var(--ds-100x);
    padding: var(--ds-sm);
    background: var(--ds-toast-bg-color);
    border-style: solid;
    border-width: var(--ds-border-width);
    border-radius: var(--ds-border-radius-sm);
    box-shadow: var(--ds-shadow-shallow);
}

.Toast-module__BorderPositive__WvGBn {
    border-color: var(--ds-color-positive);
}

.Toast-module__BorderNegative__zPlND {
    border-color: var(--ds-color-negative);
}

.Toast-module__BorderInformative__CwWHo {
    border-color: var(--ds-color-informative);
}

.Toast-module__BorderProgressive__bRtFX {
    border-color: var(--ds-color-informative);
}

.Toast-module__IconPositive__YVurf {
    color: var(--ds-color-positive);
}

.Toast-module__IconNegative__Hdxi_ {
    color: var(--ds-color-negative);
}

.Toast-module__IconInformative__Eq4v_ {
    color: var(--ds-color-informative);
}

.Toast-module__IconProgressive__t3IMn {
    color: var(--ds-color-informative);
}

.Toast-module__IconAndContent__jrUXU {
    display: flex;
    gap: var(--ds-gap-sm);
    align-items: center;
    min-width: 0;
}

.Toast-module__CloseButton__XApRV {
    color: var(--ds-toast-close-button-color);
    cursor: pointer;
}

.Toast-module__Actions__UDC1N {
    display: flex;
    flex-shrink: 0;
    gap: var(--ds-gap-sm);
    align-items: center;
}

.Toast-module__FadeIn__ovz_d {
    animation: Toast-module__fade-in__mjOmJ 0.5s;
}

.Toast-module__FadeOut__zHUdb {
    animation: Toast-module__fade-out__PI8Pr 0.5s forwards;
}

@keyframes Toast-module__fade-in__mjOmJ {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes Toast-module__fade-out__PI8Pr {
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
    }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `Toast-module__Container__KicHb`,
	"BorderPositive": `Toast-module__BorderPositive__WvGBn`,
	"BorderNegative": `Toast-module__BorderNegative__zPlND`,
	"BorderInformative": `Toast-module__BorderInformative__CwWHo`,
	"BorderProgressive": `Toast-module__BorderProgressive__bRtFX`,
	"IconPositive": `Toast-module__IconPositive__YVurf`,
	"IconNegative": `Toast-module__IconNegative__Hdxi_`,
	"IconInformative": `Toast-module__IconInformative__Eq4v_`,
	"IconProgressive": `Toast-module__IconProgressive__t3IMn`,
	"IconAndContent": `Toast-module__IconAndContent__jrUXU`,
	"CloseButton": `Toast-module__CloseButton__XApRV`,
	"Actions": `Toast-module__Actions__UDC1N`,
	"FadeIn": `Toast-module__FadeIn__ovz_d`,
	"fade-in": `Toast-module__fade-in__mjOmJ`,
	"FadeOut": `Toast-module__FadeOut__zHUdb`,
	"fade-out": `Toast-module__fade-out__PI8Pr`
};
export default ___CSS_LOADER_EXPORT___;
